import cssUtil from 'gw-portals-util-js/CssUtil';
import styles from './quoteViewCell-hashed.scss';
import templateStr from 'text!./quoteViewCell.html';

function controller() {}

export default {
    restrict: 'E',
    bindings: {
        cellData: '<',
        coverageTypeId: '<',
        coverageGroupId: '<',
        coverageId: '<'
    },
    template: cssUtil.hashTemplate(templateStr, styles),
    controller: controller
};


//////////////////
// WEBPACK FOOTER
// ./app/customer/js/src/edge/quoteandbind/common/directives/CommonOfferingSelection/common/quoteViewCell/quoteViewCell.js
// module id = 843
// module chunks = 0